import './BookingRoomingDetail.css';
import React, { FC, useContext } from "react";
import {connect} from "react-redux";
import { Button, Divider, Grid, Header, Icon, Image, Label, Segment, SegmentGroup } from "semantic-ui-react";
import { useLocation } from "react-router-dom"

import GlobalContext from "./../../contexts/GlobalContext";
import useFromSelfCheckin from "../../hooks/useFromSelfCheckin";
//import useRouter from "../../hooks/useRouter";
import { RootDispatch, RootState } from '../../store';
import { getColorCompletionRate } from '../../Utility'

import MomentCustomer from './../MomentCustomer/MomentCustomer';
import BookingRoomingButtonList from './BookingRoomingButtonList';

const mapProps = (state: RootState) => ({
  bookingsCompletionRates: state.booking.bookingsCompletionRates,
  accommodations: state.accommodation.accommodationServices,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  handleModal: dispatch.modal.handleModal,
  handleSelectedCheckIn: dispatch.checkin.handleSelected,
  handleSelectedAsync: dispatch.checkin.handleSelectedAsync,
});

type Props = {
  booking: any
  addButtons?: any
  colorGlobalCompletionRate?: any
  bookingCompletionRate?: any
} & ReturnType<typeof mapProps> & ReturnType<typeof mapDispatch>

const BookingRoomingDetailV2: FC<Props> = ({
  booking,
  accommodations,
  bookingsCompletionRates,
  handleModal,
  handleSelectedCheckIn,
  handleSelectedAsync,
}) => {
  // Hooks
  const [globalContext] = useContext(GlobalContext) as any;

  const location = useLocation();
  //const router          = useRouter();
  const fromSelfCheckin = useFromSelfCheckin(location);

  // Display data
  const bookingCompletionRateByPax = bookingsCompletionRates[booking?.id]?.detailByPax ?? {}
  const bookingCompletionRate      = bookingsCompletionRates[booking?.id]?.rate ?? 0
  const isSuccessPreCheckin        = bookingCompletionRate === 100
  const urlImage                   = accommodations?.[booking.accommodationServiceId]?.photos[0] ?? '';

  const handlePreCheckInModal = async (roomingListIndex = null, roomingListId = null) => {
    await handleSelectedAsync({
      bookingId: booking.id,
      roomingListIndex,
      roomingListId
    })
    //await getTheDataAsync()
    handleModal({preCheckInModal: true})
  }

  const handleConfirmModal = (roomingListIndex = null, roomingListId = null) => {
    handleSelectedCheckIn({
      bookingId: booking.id,
      roomingListIndex,
      roomingListId
    })
    handleModal({preCheckInConfirmModal: true})
  }
  return (
    <SegmentGroup key={booking.id} raised style={{ backgroundColor: "white" }}>
      <Grid style={{ height: "auto" }} verticalAlign="middle" columns={2}>
        <Grid.Row only="computer" style={{ height: "100%" }}>
          <Grid.Column id="alignSelfImage" mobile={16} computer={8}>
            <Image
              label={<Label as="a" color="blue" style={{ marginLeft: "2rem", marginTop: "1rem" }} ribbon><Icon name="hotel" />{booking.roomType}</Label>}
              className="p-3"
              src={urlImage}
              ui={true}
            />
          </Grid.Column>
          <Grid.Column mobile={16} computer={8} verticalAlign="middle" className="pl-4 pr-5 pb-3 pt-3">
            <Grid.Row only="computer">
              <div>
                <h3 className="title-mb" style={{ textAlign: "center" }}>
                  <span className="mr-5 mbBlue">
                    <Icon name="male" />{booking.paxTotal}
                  </span>
                  <Icon className="mr-0 mbBlue" name="calendar alternate" />
                  <span className="ml-1 mr-1" >
                    <MomentCustomer format="L">{booking.arrivalDate}</MomentCustomer>
                  </span>
                  <Icon name="long arrow alternate right" style={{ margin: "0" }} />
                  <span className="ml-1">
                    <MomentCustomer format="L">{booking.departureDate}</MomentCustomer>
                  </span>
                </h3>
              </div>
            </Grid.Row>
            <Grid.Row verticalAlign="middle" only="computer">
              <Grid.Column computer={16} verticalAlign="middle">
                <Header className="mt-3 pt-3 pb-3" textAlign="center" as="h3">
                  <p style={{ color: getColorCompletionRate(bookingCompletionRate) }}>
                    {globalContext.translations.preCheckInMessage} {bookingCompletionRate} %
                  </p> 
                  {globalContext.translations.preCheckInAddMessage}
                </Header>
              </Grid.Column>
              <Grid.Column mobile={16} computer={16} stretched verticalAlign="middle" className="pb-3">
                <Grid.Row>
                  <BookingRoomingButtonList
                    roomingList={booking.roomingList}
                    paxTotal={booking.paxTotal}
                    bookingCompletionRateByPax={bookingCompletionRateByPax}
                    handlePreCheckInModal={handlePreCheckInModal}
                    handleConfirmModal={handleConfirmModal}
                  />
                </Grid.Row>
                {fromSelfCheckin.isFromSelfCheckin && isSuccessPreCheckin &&
                  <Grid.Row>
                    <Grid.Column computer={16} verticalAlign="middle">
                      <Button
                        className="roomAccessAction"
                        content={globalContext.translations.getRoomAccessActionsLink}
                        color="blue"
                        fluid
                        onClick={() => handleModal({successSelfCheckinModal: true})}
                      />
                    </Grid.Column>
                  </Grid.Row>
                }
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row only="mobile tablet">
          <Grid.Column mobile={16} computer={8}>
            <Image
              label={<Label as="a" color="blue" style={{ marginLeft: "1rem", marginTop: "1rem" }} ribbon><Icon name="hotel" />{booking.roomType}</Label>}
              src={urlImage}
              ui={true}
            />
          </Grid.Column>
          <Grid.Column mobile={16} computer={8} verticalAlign="middle" /*className="pl-4 pr-4 pb-1"*/>
            <Segment textAlign="center" className="bookingDetail">
              <span className="mr-4"><Icon name="user" />
                {booking.paxTotal}
              </span>
              <span className="ml-3 mr-1">
                <MomentCustomer format="L">{booking.arrivalDate}</MomentCustomer>
              </span>
              <Icon name="long arrow alternate right" />
              <span className="">
                <MomentCustomer format="L">{booking.departureDate}</MomentCustomer>
              </span>
            </Segment>
            <Header className="mt-3" textAlign="center" as="h3">
              {globalContext.translations.preCheckInAddMessage}
            </Header>
            <Grid.Row>
              <BookingRoomingButtonList
                roomingList={booking.roomingList}
                paxTotal={booking.paxTotal}
                bookingCompletionRateByPax={bookingCompletionRateByPax}
                handlePreCheckInModal={handlePreCheckInModal}
                handleConfirmModal={handleConfirmModal}
              />
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </SegmentGroup>
  )
};

export default connect(mapProps, mapDispatch)(BookingRoomingDetailV2);